module.exports = __webpack_public_path__ + "static/media/stars.c631b5f2.svg";